import { OrderItemUI } from '@azavista/payments';

export const getOrderItemTrackByValue = (item: OrderItemUI, index: number) => {
    return `${item.id}_${item.transaction_date}__${index}`;
};
